import React, {Fragment, useState} from 'react';
import Box from '../layout/Box';
import createEditor, {PlaceHolderComponent} from '../form/ComponentEditor';
import ShippingEditor from "./shippingEditor";
import BoxEditor from "./BoxEditor";
import PurchaseList from "./lists/purchaseList";
import PurchaseForm from "./forms/purchaseForm";
import InvoiceEditor from "./invoiceEditor";
import ModalEditor from "./ModalEditor";
import {postData, sendRequest} from "../../utils/request";
import Modal from "../layout/Modal";
import Button from "../form/Button";
import {Payments} from "./paymentEditor";
import StoreOrderEditor, {StoreOrderClaim} from "./storeorder/storeorderEditor";
import {connect} from "src/store";
import isEqual from "lodash-es/isEqual";
import {withSnackbar} from "notistack";
import {SelectButton} from "primereact/selectbutton";
import Payment from "./OperationList/Elements/Payment";
import get from "../../utils/get";
import {set} from "../../utils/dotutils";
import CheckBox from "../form/CheckBox";
import Collapse from "../layout/Collapse";
import {operation} from "../../utils/other";
import Confirm from "../form/Confirm";
import Select from "src/components/form/Select";
import Items from "src/components/editors/forms/Purchase/Items";
import debounce from "lodash-es/debounce";

export const stateConst = {
    Initiated: 0,
    Modification: 50,
    Preorder: 75,
    UnderRevision: 100,
    CheckPayments: 102,
    WaitingForPrepayment: 105,
    MissingStock: 107,
    WaitingForStock: 110,
    StockReserved: 120,
    OriginStoreOrderDelete: 130,
    OriginStoreOrderSent: 200,
    OriginStoreOrderClaim: 210,
    ClientSettled: 215,
    OriginStoreOrderCompleted: 220,
    ShippingOrdered: 300,
    ShippingFailed: 310,
    ShippingCompleted: 320,
    DestinationStoreOrderSent: 400,
    Correctional: 405,
    DestinationStoreOrderClaim: 410,
    PurchasePriceModification: 507,
    WaitingForPostpayment: 513,
    PurchaseCompleted: 520,
    DestinationStoreOrderReversal: 910,
    DestinationStoreOrderReversalSent: 915,
    DestinationStoreOrderReversed: 920,
    ShippingReversal: 930,
    ReverseShippingFailed: 935,
    ReverseShippingCompleted: 940,
    OriginStoreOrderReversalSent: 950,
    OriginStoreOrderReversed: 960,
    WaitingForPaymentSettlement: 980,
    Deleted: 990,
};

const stateType = {};
Object.keys(stateConst).forEach((key) => {
    stateType[key] = (state, operator) => operation(state, stateConst[key], operator)
});
export {stateType};


export class PurchaseEditor extends React.Component {

    stateButtons = (state) => {
        return {
            [stateConst.MissingStock + ""]: "Várakoztatás",
            [stateConst.OriginStoreOrderCompleted + ""]: "Szállítás újra rendelése"
        }[state + ""] || "Mehet";
    };

    stateButtonEnabled = (state) => [
        stateType.Initiated,
        stateType.Modification,
        stateType.Preorder,
        stateType.UnderRevision,
        stateType.CheckPayments,
        stateType.WaitingForPrepayment,
        stateType.MissingStock,
        stateType.WaitingForStock,
        stateType.StockReserved,
        stateType.OriginStoreOrderClaim,
        stateType.ClientSettled,
        stateType.OriginStoreOrderCompleted,
        stateType.ShippingFailed,
        stateType.ShippingCompleted,
        stateType.DestinationStoreOrderSent,
        stateType.Correctional,
        stateType.DestinationStoreOrderClaim,
        stateType.PurchasePriceModification,
        stateType.WaitingForPostpayment,
        stateType.PurchaseCompleted,
        stateType.WaitingForPaymentSettlement,
    ].some((f) => f(state));

    state = {
        direction_type: ['out','in'],
        recreateValue: {
            sendPaymentNotification: true
        },
        editableFields: [],
        modifiable: false
    };

    constructor(props) {
        super(props);
        this.loadEditableFields();
    }

    loadEditableFields = debounce(() => {
        this.loadEditableFieldsRequest?.abort();
        if (this.props.values[this.props.componentConfig.idfield]) {
            this.loadEditableFieldsRequest = postData({
                action: this.props.componentConfig.componentname + '.getModificationConfig',
                [this.props.componentConfig.idfield]: this.props.values[this.props.componentConfig.idfield],
            });
            this.loadEditableFieldsRequest.then((res) => {
                this.setState({
                    editableFields: res.fields,
                    modifiable: res.modifiable
                });
            });
        } else {
            this.setState({
                editableFields: [],
                modifiable: false
            });
        }
    });

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (
            prevProps.values[prevProps.componentConfig.idfield] + "" !== "" + this.props.values[this.props.componentConfig.idfield]
            ||
            parseInt(this.props.values.modifying || "0") !== parseInt(prevProps.values.modifying || "0")
            ||
            parseInt(this.props.values.state || "0") !== parseInt(prevProps.values.state || "0")
        ) {
            this.setState({
                editableFields: [],
                modifiable: false
            });
            this.loadEditableFields();
        }
    }

    proceedState = async () => {
        const values = this.props.values;
        await this.props.processAction(async () => {
            const response = await postData({
                action: this.props.componentConfig.componentname + '.proceedState',
                data: values
            });
            if (response.success) {
                this.list && this.list.refreshBackground();
                this.form && this.form.refreshBackground();
            }
            return response;
        });
    }

    recreate = async () => {
        if (!this.state.recreateState) {
            this.setState({recreateState: true});
            return;
        }
        await this.props.processAction(async () => {
            const response = await postData({
                action: this.props.componentConfig.componentname + '.recreate',
                [this.props.componentConfig.idfield]: this.props.values[this.props.componentConfig.idfield],
                ...this.state.recreateValue,
                payment: this.state.recreateValue.newPayment ? this.state.recreateValue.payment : undefined,
            });
            if (response.success) {
                this.setState({
                    recreateValue: {
                        sendPaymentNotification: true
                    },
                    recreateState: false
                })
                this.list && this.list.refreshBackground();
                this.form && this.form.refreshBackground();
            }
            return response;
        });
    }

    createRetraxit = async () => {
        await this.props.processAction(async () => {
            const cb = async (id) => {
                const data = {
                    action: 'OperationList.doAction',
                    actionname: 'createPurchaseFrom',
                    id,
                    purchase: this.props.values[this.props.componentConfig.idfield]
                };
                await postData(data);
                this.props.setContent("Retraxit", {id});
                this.list && this.list.refreshBackground();
                this.form && this.form.refreshBackground();
            }
            const operationlist = await sendRequest({
                option: "OperationList",
                filter: [
                    {expression: "JSON_EXTRACT({{xtradata}}, '$.purchase')", value: this.props.values[this.props.componentConfig.idfield]},
                ],
            });
            if (!operationlist.id) {
                const response = await postData({
                    action: 'OperationList.create',
                    data: {
                        preset: 'Retraxit'
                    }
                });
                if (response.success) {
                    await cb(response.data.id);
                }
            } else {
                await cb(operationlist.id);
            }
            return {success: true};
        });
    }

    sendProform = async () => {
        await this.props.processAction(async () => {
            const response = await postData({
                action: 'TransactionalMailHandler.sendProform',
                component_type: this.props.componentConfig.componentname,
                component_id: this.props.values[this.props.componentConfig.idfield]
            });
            if (response.success) {
                this.list && this.list.refreshBackground();
                this.form && this.form.refreshBackground();
            }
            this.props.enqueueSnackbar('Proforma kiküldve!', {
                variant: 'success',
            });
            return response;
        });
    }

    getValue = (name) => {
        return get(this.state.recreateValue, name, undefined);
    }

    getProps = (name) => {
        let props = {...this.props.getFieldProps(name)};
        props = {...props, ...this.props[name]};
        if (!props.disabled) {
            const disabled = this.props.disabled;//Array.isArray(this.props.disabled) ? this.props.disabled : [this.props.disabled];
            props.disabled = (!Array.isArray(disabled) && disabled) || (Array.isArray(disabled) && disabled.indexOf(name) !== -1);
            if (this.props[name]) {
                props = {
                    ...this.props[name],
                    ...props,
                    disabled: this.props[name].disabled || props.disabled
                };
            }
        }
        return props;
    }

    setFieldValue = (field, name) => {
        let recreateValue = JSON.parse(JSON.stringify(this.state.recreateValue || {}));
        set(recreateValue, field, name);
        this.setState({recreateValue});
    }

    render() {

        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        const Other = this.props.other || Fragment;

        let {listFilter} = this.props;
        if (!listFilter) {
            listFilter = [];
        }

        const partnerType = this.props.partnerType || "customer";

        const actionButtons = [];
        const modifying = parseInt(this.props.values.modifying);
        if (!modifying) {
            if (stateType.MissingStock(this.props.values.state)) {
                actionButtons.push(
                    <Confirm
                        key="8"
                        color="primary"
                        className="pull-right"
                        header="Biztos mehet?"
                        body="Biztos elengeded? A hiányban lévő tételek módosításra kerülnek!"
                        onAccept={async () => {
                            const values = this.props.values;
                            await this.props.processAction(async () => {
                                const response = await postData({
                                    action: this.props.componentConfig.componentname + '.proceedState',
                                    data: values,
                                    modify_stock: true
                                });
                                if (response.success) {
                                    this.list && this.list.refreshBackground();
                                    this.form && this.form.refreshBackground();
                                }
                                return response;
                            });
                        }}
                    >
                        Mehet
                    </Confirm>
                );
            }
            if (!stateType.PurchaseCompleted(this.props.values.state)) {
                actionButtons.push(
                    <Button
                        key="1"
                        disabled={this.props.isLoading || !this.stateButtonEnabled(this.props.values.state)}
                        color="primary"
                        className="pull-right"
                        onClick={this.proceedState}
                    >
                        {this.stateButtons(this.props.values.state)}
                    </Button>
                );
            }
        }
        if (stateType.WaitingForPrepayment(this.props.values.state)) {
            actionButtons.push(
                <Button
                    key="100"
                    disabled={this.props.isLoading}
                    color="default"
                    className="pull-right"
                    onClick={this.sendProform}
                >
                    Proforma küldése
                </Button>
            );
        }
        if (this.state.modifiable) {
            actionButtons.push(
                <Confirm
                    key="10"
                    disabled={this.props.isLoading}
                    color="warning"
                    header={modifying ? "Biztos kilépsz a módosításból?" : "Biztos módosítod?"}
                    body={modifying ? "Biztos kilépsz a módosításból?" : "Biztos módosítod?"}
                    acceptButton={modifying ? "Véglegesítés" : "Módosítás"}
                    className="pull-right"
                    onAccept={async () => {
                        const values = this.props.values;
                        await this.props.processAction(async () => {
                            const response = await postData({
                                action: this.props.componentConfig.componentname + '.' + (modifying ? 'resume' : 'suspend'),
                                data: values
                            });
                            if (response.success) {
                                this.list?.refreshBackground();
                                this.form?.refreshBackground();
                            }
                            return response;
                        });
                    }}
                >
                    {modifying ? "Véglegesítés" : "Módosítás"}
                </Confirm>
            );
        }

        if (
            this.props.values.retraxit_count !== undefined
            &&
            this.props.values.original_purchase !== undefined
            &&
            parseInt(this.props.values.retraxit_count || "0") === 0
            &&
            !this.props.values.original_purchase
        ) {
            if (
                stateType.PurchaseCompleted(this.props.values.state)
                &&
                !this.props.values.pos?.location?.id
            ) {
                actionButtons.push(
                    <Confirm
                        key="4"
                        header="Elállás"
                        body="Az elállásban szereplő tételeket a következő oldalon módosíthatók!"
                        color="danger"
                        className="pull-right"
                        disabled={this.props.disabled || this.props.isLoading}
                        acceptButton="Igen, eláll tőle"
                        onAccept={this.createRetraxit}
                    >
                        Elállás
                    </Confirm>
                );
            }
            actionButtons.push(
                <Button
                    key="2"
                    disabled={!this.props.values[this.props.componentConfig.idfield] || this.props.isLoading}
                    color="danger"
                    onClick={this.props.deleteForm}
                >
                    Törlés
                </Button>
            );
        }
        if (this.props.values[this.props.componentConfig.idfield] && stateType.Deleted(this.props.values.state)) {
            actionButtons.push(
                <Fragment
                    key="50"
                >
                    <Button
                        key="50"
                        disabled={this.props.isLoading}
                        color="default"
                        onClick={this.recreate}
                    >
                        Visszaállítás
                    </Button>
                    <Modal
                        state={this.state.recreateState ? "on" : "off"}
                        size="medium"
                        theme="default"
                        header="Visszaállítás"
                        buttons={[
                            {
                                text: 'Mégse',
                                props: {color: "default", disabled: this.props.disabled || this.props.isLoading},
                                onClose: true,
                                onClick: async () => {
                                    try {
                                        this.setState({recreateState: false});
                                    } catch (e) {

                                    }
                                }
                            },
                            {
                                text: 'Visszaállítás',
                                props: {color: "primary", disabled: this.props.disabled || this.props.isLoading},
                                onClick: async () => {
                                    this.recreate();
                                }
                            },
                        ]}
                    >
                        <div className="row form-row">
                            <div className="col-md-12">
                                <CheckBox
                                    name={"newPayment"}
                                    value={this.state.recreateValue.newPayment}
                                    label="Új fizetésimóddal"
                                    saveChanges={(field, newPayment) => {
                                        this.setFieldValue("newPayment", newPayment);
                                    }}
                                />
                            </div>
                        </div>
                        <div className="row form-row">
                            <Collapse collapsed={!!this.state.recreateValue.newPayment}>
                                <div>
                                    <Payment
                                        props={{
                                            values: this.state.recreateValue,
                                            getFieldProps: this.getProps,
                                            getProps: this.getProps,
                                            getValue: this.getValue,
                                            setFieldValue: this.setFieldValue
                                        }}
                                    />
                                </div>
                            </Collapse>
                        </div>
                        <div className="row form-row">
                            <div className="col-md-12">
                                <CheckBox
                                    name={"sendPaymentNotification"}
                                    value={this.state.recreateValue.sendPaymentNotification}
                                    label="Fizetés link(ek) kiküldése"
                                    saveChanges={(field, sendPaymentNotification) => {
                                        this.setFieldValue("sendPaymentNotification", sendPaymentNotification);
                                    }}
                                />
                            </div>
                        </div>
                    </Modal>
                </Fragment>
            );
        }
        if (
            stateType.PurchaseCompleted(this.props.values.state)
            ||
            stateType.WaitingForPostpayment(this.props.values.state)
        ) {
            actionButtons.push(
                <StoreOrderClaim
                    key="6"
                    {...this.props}
                />
            );
        }

        const direction_types = [
            {label: 'Kimenő', value: 'out'},
            {label: 'Bejövő', value: 'in'}
        ];
        if (!listFilter) {
            listFilter = [];
        } else {
            if (Array.isArray(listFilter)) {
                listFilter = [...listFilter];
            } else if (!listFilter) {
                listFilter = [listFilter];
            }
        }
        if (this.props.till) {
            const currentPartner = (((this.props.till || {}).pos || {}).partner || {}).partner_id;
            if (JSON.stringify(this.state.direction_type) === JSON.stringify(["out"])) {
                listFilter = [...listFilter, {field: "seller", value: currentPartner}];
            } else if (JSON.stringify(this.state.direction_type) === JSON.stringify(["in"])) {
                listFilter = [...listFilter, {field: "customer", value: currentPartner}];
            }
        }

        return (
            <Fragment>
                <List
                    {...this.props}
                    collapsed={this.props.collapsed || false}
                    theme="default"
                    header={"Tranzakció lista"}
                    actions={!!this.props.till && <SelectButton
                        value={this.state.direction_type}
                        multiple={true}
                        options={direction_types}
                        onChange={(e) => this.setState({direction_type: e.value.length ? e.value : this.state.direction_type})}
                    />}
                >
                    <PurchaseList
                        ref={(el) => this.list = el}
                        {...this.props}
                        filter={listFilter}
                        partnerType={partnerType}
                    />
                </List>
                {this.props.values[this.props.componentConfig.idfield] && <Editor
                    {...this.props}
                    header={"Tranzakció adatai"}
                    footer={actionButtons}
                >
                    <PurchaseForm
                        ref={(form) => this.form = form}
                        stateConst={stateConst}
                        stateType={stateType}
                        editableFields={this.state.editableFields}
                        {...this.props}
                        partnerType={partnerType}
                    />
                </Editor>}
                <Other>
                    {
                        this.props.values[this.props.componentConfig.idfield]
                        &&
                        this.props.values.origin?.id !== this.props.values.destination?.id
                        &&
                        <Fragment>
                            <StoreOrderEditor
                                editorContext="purchaseStoreOrderEditorOut"
                                gridid="purchaseStoreOrderListOut"
                                collapsed={!(parseInt(this.props.values.state + "") >= 200 && parseInt(this.props.values.state + "") <= 220)}
                                out={true}
                                client={this.props}
                                listFilter={[
                                    {
                                        field: "client_component",
                                        value: this.props.componentConfig.componentname
                                    },{
                                        field: "client_component_id",
                                        value: this.props.values[this.props.componentConfig.idfield]
                                    }
                                ]}
                                editor={ModalEditor}
                                selection={null}
                                onProcessAction={() => {
                                    if (!this.props.isLoading) {
                                        this.props.reloadForm && this.props.reloadForm();
                                    }
                                }}
                            />
                            <ShippingEditor
                                editorContext="purchaseShippingEditor"
                                gridid="purchaseShippingList"
                                pageSize={0}
                                presets={{
                                    client_component: this.props.componentConfig.componentname,
                                    client_component_type: this.props.componentConfig.componentname,
                                    client_component_id: this.props.values[this.props.componentConfig.idfield],
                                }}
                                collapsed={!(parseInt(this.props.values.state + "") >= 220 && parseInt(this.props.values.state + "") < 400)}
                                editor={ModalEditor}
                                businessComponent={this.props}
                                disable={!(stateType.ShippingFailed(this.props.values.state) || stateType.OriginStoreOrderCompleted(this.props.values.state))}
                                selection={null}
                                saveForm={async () => {
                                    this.props.reloadForm && this.props.reloadForm();
                                }}
                                onProcessAction={() => {
                                    if (!this.props.isLoading) {
                                        this.props.reloadForm && this.props.reloadForm();
                                    }
                                }}
                            />
                            <StoreOrderEditor
                                editorContext="purchaseStoreOrderEditorIn"
                                gridid="purchaseStoreOrderListIn"
                                collapsed={!(parseInt(this.props.values.state + "") >= 400 && parseInt(this.props.values.state + "") <= 420)}
                                in={true}
                                client={this.props}
                                listFilter={[
                                    {
                                        field: "client_component",
                                        value: this.props.componentConfig.componentname
                                    },{
                                        field: "client_component_id",
                                        value: this.props.values[this.props.componentConfig.idfield]
                                    }
                                ]}
                                editor={ModalEditor}
                                selection={null}
                                onProcessAction={() => {
                                    if (!this.props.isLoading) {
                                        this.props.reloadForm && this.props.reloadForm();
                                    }
                                }}
                            />
                        </Fragment>
                    }
                    {
                        this.props.values[this.props.componentConfig.idfield]
                        &&
                        <Fragment>
                            <Payments
                                {...this.props}
                                collapsed={!(parseInt(this.props.values.state + "") < 107 || parseInt(this.props.values.state + "") >= 500)}
                                disable={!(stateType.WaitingForPrepayment(this.props.values.state) || stateType.CheckPayments(this.props.values.state) || modifying)}
                            />
                            <InvoiceEditor
                                editorContext="purchaseInvoiceEditor"
                                gridid="purchaseInvoiceList"
                                pageSize={0}
                                collapsed={!(parseInt(this.props.values.state + "") >= 500)}
                                client={this.props}
                                listFilter={[
                                    {
                                        field: "component",
                                        value: this.props.componentConfig.componentname
                                    },{
                                        field: "component_id",
                                        value: this.props.values[this.props.componentConfig.idfield]
                                    }
                                ]}
                                editor={ModalEditor}
                                selection={null}
                                onProcessAction={() => {
                                    if (!this.props.isLoading) {
                                        this.props.reloadForm && this.props.reloadForm();
                                    }
                                }}
                            />
                        </Fragment>
                    }
                </Other>
            </Fragment>
        );
    }
}

const Wrapped = withSnackbar(PurchaseEditor);

Wrapped.placeHolder = PlaceHolderComponent;

const Editor = connect((state) => {
    return {
        context: state.app.context
    };
}, {})(createEditor({
    componentName: "purchase",
    WrappedComponent: Wrapped,
    props: {
        view: "admin"
    }
}));

export const purchasesEditor = (props) => {
    let {listFilter} = props;
    if (!listFilter) {
        listFilter = [];
    } else {
        if (Array.isArray(listFilter)) {
            listFilter = [...listFilter];
        } else if (!listFilter) {
            listFilter = [listFilter];
        }
    }
    let operator = "=";
    if (Array.isArray(props.pos)) {
        listFilter.push({field: "pos", value: props.pos.map((pos) => pos instanceof Object ? pos.id : pos), operator: "in"});
    } else if (props.pos instanceof Object) {
        let value = (props.pos || {}).id;
        if (!(props.pos || {}).id) {
            operator = "isnull";
            value = undefined;
        }
        listFilter.push({field: "pos", value, operator});
    } else {
        let value = props.pos;
        if (!value) {
            operator = "isnull";
            value = undefined;
        }
        listFilter.push({field: "pos", value, operator});
    }
    return <Editor {...props} listFilter={listFilter} editorContext="purchases"/>;
}

export const ConsignmentPurchasesEditor = connect((state) => {
    return {
        pos: (state.app.till || {}).pos || {},
    };
}, {})((props) => {
    let {listFilter} = props;
    if (!listFilter) {
        listFilter = [];
    } else {
        if (Array.isArray(listFilter)) {
            listFilter = [...listFilter];
        } else if (!listFilter) {
            listFilter = [listFilter];
        }
    }
    listFilter.push({field: "destination", operator: "isnull"});
    listFilter.push({field: "origin", operator: "isnull"});
    listFilter.push({field: "customer", value: ((props.pos || {}).partner || {}).partner_id});
    return (
        <Editor {...props} listFilter={listFilter} editorContext="ConsignmentPurchases"/>
    );
});

export const SupplyPurchasesEditor = connect((state) => {
    return {
        pos: (state.app.till || {}).pos,
    };
}, {})((props) => {
    let {listFilter} = props;
    if (!listFilter) {
        listFilter = [];
    } else {
        if (Array.isArray(listFilter)) {
            listFilter = [...listFilter];
        } else if (!listFilter) {
            listFilter = [listFilter];
        }
    }
    listFilter.push({field: "destination.partner", value: props.pos.partner.partner_id});
    listFilter.push({field: "pos", operator: "isnull"});
    return <Editor {...props} editorContext="SupplyPurchases" partnerType="seller" listFilter={listFilter}/>;
});

export const PurchaseReturnsEditor = connect((state) => {
    return {
        pos: (state.app.till || {}).pos || {},
    };
}, {})((props) => {
    let {listFilter} = props;
    if (!listFilter) {
        listFilter = [];
    } else {
        if (Array.isArray(listFilter)) {
            listFilter = [...listFilter];
        } else if (!listFilter) {
            listFilter = [listFilter];
        }
    }
    listFilter.push({field: "seller", value: props.pos.partner.partner_id});
    listFilter.push({field: "destination", operator: "isnull"});
    listFilter.push({field: "pos", operator: "isnull"});
    return <Editor {...props} editorContext="PurchaseReturns" partnerType="seller" listFilter={listFilter}/>;
});

export default connect((state) => {
    return {
        pos: (state.app.till || {}).pos || {},
        till: state.app.till,
    };
}, {})((props) => {
    let {listFilter} = props;
    if (!listFilter) {
        listFilter = [];
    } else {
        if (Array.isArray(listFilter)) {
            listFilter = [...listFilter];
        } else if (!listFilter) {
            listFilter = [listFilter];
        }
    }
    if (props.pos && (props.pos || {}).id) {
        let operator = "=";
        let value = (props.pos || {}).id;
        if (!props.pos.id) {
            operator = "isnull";
            value = undefined;
        }
        listFilter.push({field: "pos", value, operator});
    }
    return <Editor {...props} listFilter={listFilter}/>;
});